import React, { useState, useContext } from "react";

import './styles.css';

import ProfileForm from "../../components/Forms/ProfileForm/ProfileForm";
import useAuthClient from "../../hooks/useAuthClient";
import useSetPageTitle from "../../hooks/useSetPageTitle";
import UserContext from "../../contexts/UserContext";

import {
    validateName,
    validateEmail,
    validatePhone,
} from '../../validation/index';

function Profile() {
    const { currentUser, currentPromo } = useContext(UserContext);

    useAuthClient(currentPromo);
    useSetPageTitle('Perfil', currentPromo);

    const [name, setName] = useState(currentUser.nome);
    const [nameWarning, setNameWarning] = useState('');

    const [email, setEmail] = useState(currentUser.email);
    const [emailWarning, setEmailWarning] = useState('');

    const [phone, setPhone] = useState(currentUser.telefone);
    const [phoneWarning, setPhoneWarning] = useState('');

    const handleName = (inputedName) => validateName(inputedName, setName, setNameWarning);
    const handleEmail = (inputedEmail) => validateEmail(inputedEmail, setEmail, setEmailWarning);
    const handlePhone = (inputedPhone) => validatePhone(inputedPhone, setPhone, setPhoneWarning);

    return(
        <div className="container">
            <ProfileForm
                cpf={currentUser.doc}
                name={name}
                setName={handleName}
                nameWarning={nameWarning}
                setNameWarning={setNameWarning}
                email={email}
                setEmail={handleEmail}
                setEmailWarning={setEmailWarning}
                emailWarning={emailWarning}
                phone={phone}
                setPhone={handlePhone}
                setPhoneWarning={setPhoneWarning}
                phoneWarning={phoneWarning}
            />
        </div>        
    )
}

export default Profile;